import React, { useState } from 'react';
import { Text } from '@radix-ui/themes';
import avatarIcon from '../../../../assets/images/avatar.png';
import crownGlIcon from '../../../../assets/images/crown_gl.png';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { User } from 'models/User';

const RpNominateGroupleader = ({ onNominate, data, isGlTransfer }) => {

    const profileData = useSelector((state: RootState) => state?.auth?.user as User);
    // const batchData = useSelector((state: any) => state?.session?.sessionData?.batch?.participants);
    const batchData = useSelector((state: RootState) => state.live.settings?.batch.participants);
    const [selected, setSelected] = useState(-1);

    const getProfileImage = (email) => {
        const participant = batchData?.find((x) => x?.email === email || x?.participant_email === email);
        return participant?.profilePhoto;
    };

    const titleMsg = isGlTransfer
        ? 'Go ahead & transfer your Group Leader role to someone else in your group'
        : 'Hey! The Trainer would like each Group to pick a Group Leader! Go ahead & click a crown now!';

    return (
        <div className="flex flex-1 justify-center items-center p-[4vw]">
            <Text
                as="span"
                size="3"
                className="text-white font-[Lato-Regular] text-center"
            >
                {titleMsg}
            </Text>
            <ul className="max-h-[40vh] my-[2vh] w-full">
                {data.map((item, index) => {
                    if (item?.participant_email?.toLowerCase() !== profileData?.email?.toLowerCase()) {
                        return (
                            <li key={item?.id}>
                                <button
                                    className="flex w-[50vw] items-center my-[0.5vh]"
                                    onClick={() => setSelected(index)}
                                >
                                    <img
                                        src={getProfileImage(item?.participant_email) || avatarIcon}
                                        alt="User"
                                        className="h-[10vw] w-[10vw] rounded-full border border-white mx-[4vw]"
                                    />
                                    <Text
                                        as="span"
                                        size="4"
                                        className="text-white font-[Lato-Regular] flex-1"
                                    >
                                        {item?.participant_name}
                                    </Text>
                                    <img
                                        src={crownGlIcon}
                                        alt="Crown"
                                        className={`h-[5vw] w-[5vw] object-contain ${selected === index ? 'tint-[#E9BE50]' : 'tint-[#757575]'}`}
                                    />
                                </button>
                            </li>
                        );
                    }
                    return null;
                })}
            </ul>
            {!isGlTransfer && (
                <Text
                    as="span"
                    size="3"
                    className="text-white font-[Lato-Regular] text-center"
                >
                    The group member with most nominations becomes your Group Leader! In case of a tie, system gets to decide!
                </Text>
            )}
            <button
                onClick={() => onNominate(data[selected])}
                className="px-[6vw] py-[1.5vh] bg-[#43A047] mb-[2vh] rounded-[4vw] shadow-md"
            >
                <Text
                    as="span"
                    size="3"
                    className="text-white font-[Lato-Regular]"
                >
                    {isGlTransfer ? 'Transfer' : 'Nominate!'}
                </Text>
            </button>
        </div>
    );
};

export default RpNominateGroupleader;